import $ from 'jquery'

$('.woocommerce-notices-wrapper').on('click', function () {
    $(this).html('')
})

$(document).ready(function() {
    if ($('.woocommerce-error').length > 0) {
        $('.cc-custom-fields').find('.cc-input').each(function() {
            if ($(this).val().trim() === '') {
                $(this).css('border', '2px solid #D30000');
            }
        });
    }
});
